// @ts-ignore
import projectConfig from "@projectConfig";
import "./FormDevInfo.less";
import React from "react";

type FormDevInfoProps = {
   formUuid: string;
   formId: number;
   form: any;
   instanceId: number;
   recordId: number;
};

const FormDevInfo: React.FC<FormDevInfoProps> = ({
   formUuid,
   formId,
   form,
   instanceId,
   recordId
}) => {
   const { hostB2 } = projectConfig.api;

   return (
      <span className="dev-info dev-info-padding">
         <p>
            formUuid: <b>{formUuid}</b>
         </p>
         <p>
            form id: <b>{formId}</b>
         </p>
         <p>
            form builder:{" "}
            <b>
               <a
                  href={`${hostB2}/index.php/Forms/FormBuilder?mid=0&fid=${formId}`}
                  target="_blank"
               >
                  Click me!
               </a>
            </b>
         </p>
         <p>
            Instance diagram:{" "}
            <b>
               <a
                  href={`${hostB2}/index.php/workflow/workflowInstance/editor/id/${instanceId}`}
                  target="_blank"
               >
                  (#{instanceId})
               </a>
            </b>
         </p>
         <p>
            Main record ID: <b>{recordId}</b>
         </p>
         <button
            onClick={(e) => {
               e.preventDefault();
               // Don't remove it. It's for debugging
               console.log(form.getFieldsValue());
            }}
            type="button"
         >
            Get values from the fields
         </button>
      </span>
   );
};

export default FormDevInfo;
